<script lang="ts">
	let { html }: { html: string } = $props();
</script>

<span
	class="rounded-pill bg-surface text-accent mb-[22px] inline-flex items-center gap-2 border border-[#fdebc8] px-3.5 py-[7px] text-[13px] font-semibold tracking-[0.01em]"
	>{@html html}</span
>
